module.exports = __webpack_public_path__ + "img/happytable_product3.78b4217d.jpg";